// extracted by mini-css-extract-plugin
export default {"selectIsActive":"SelectHighlighting_selectIsActive__g7GVD","selectIsNotActive":"SelectHighlighting_selectIsNotActive__ii5W-"};